import { render, staticRenderFns } from "./EventCalendarHolidayReadOnly.vue?vue&type=template&id=6c647c24&"
import script from "./EventCalendarHolidayReadOnly.vue?vue&type=script&lang=ts&"
export * from "./EventCalendarHolidayReadOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports